module.exports =
  # Generic verbs
  'UPDATE': '更新'
  'SAVE': '保存する'
  'EDIT': '編集'
  'SEND': '送信'
  'CLOSE': '閉じる'
  'CANCEL': 'キャンセル'
  'UNSUBSCRIBE': '解約する'
  'PROCESSING': '処理中...'
  'SHOW_MORE': 'もっと見る'
  'CONFIRMATION_MSG': '本当によろしいですか?'
  'OK': 'OK'

  # Generic golf terms
  'SCORE': 'スコア'
  'PUTTS': 'パット'

  # Generic words
  'YEAR': '年'
  'MONTH': '月'
  'DAY': '日'

  # Validation
  'VALIDATION':
    'REQUIRED': '入力必須です。'
    'MATCH': '入力内容が一致しません。'
    'EMAIL': '正しい email address を入力して下さい。'
    'MIN_LENGTH': "英大文字・英小文字・数字・記号のうち3種以上かつ{{ n }} 桁以上(半角)で入力して下さい。"
    'MAX_LENGTH': "{{ n }} 文字以下で入力して下さい。"
    'DATE': "正しい日付を入力して下さい。"
    'NUMERIC': "数値を入力して下さい。"
    'MIN_VALUE': "{{ n }} より大きい値を入力して下さい。"
    'MAX_VALUE': "{{ n }} より小さい値を入力して下さい。"
    'STRENGTH': "英大文字・英小文字・数字・記号のうち3種以上かつ10桁以上(半角)で入力して下さい。"
  # Generic API Messages
  'API_SUCCESS': '変更内容を保存しました。'
  'API_ERROR': '変更内容の保存に失敗しました。入力内容を確認して再度お試し下さい。'
  'EMAIL_DUPLICATED': '指定したメールアドレスは既に使われています。別のメールアドレスをご利用下さい。'
  'NAME_DUPLICATED': 'その名前は既に登録されています。別の名前を入力してください。'
  'CURRENT_PASSWORD_ERROR': '入力されたパスワードは間違っています。'

  # Common
  'NO_ROUND':
    'LETS_CREATE': 'ラウンド情報を登録しよう！'
    'CREATE_NOW': 'スコア登録はコチラ'

  'AGENCY_DENINED': "入力代行依頼中のため編集できません."



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/core/translation/common.ja.coffee